{
  "slug": "iq-score-ranges-explained",
  "title": "Gammes de score de QI expliquées",
  "description": "Explorez les bandes de score de QI communes, les centiles approximatifs, les intervalles de confiance et les limites des étiquettes.",
  "summary": "Les bandes de QI sont des résumés pratiques, mais les limites et les étiquettes varient selon le test, et les scores doivent être interprétés comme des estimations et dans leur contexte.",
  "sections": [
    {
      "heading": "Un guide pratique des gammes communes",
      "paragraphs": [
        "Pour une échelle avec une moyenne de 100 et écart-type de 15, ces bandes fournissent une orientation générale. Ce ne sont pas des catégories de diagnostic."
      ],
      "bullets": [
        "130 et au-dessus: environ le sommet 2%",
        "120–129: environ le 91st–9710e centiles",
        "110–119: environ le 75th–9010e centiles",
        "90–109: large gamme moyenne",
        "80–89: environ le 9th–2410e centiles",
        "70–79: environ le 2nd–810e centiles",
        "Below 70: approximativement le plus bas. 2%"
      ]
    },
    {
      "heading": "Pourquoi les étiquettes diffèrent",
      "paragraphs": [
        "Les éditeurs et les institutions utilisent des termes et des seuils différents, un résultat à une limite n'est pas significativement différent d'un résultat à un point éloigné, et les intervalles de confiance traversent souvent plus d'une bande.",
        "Les résultats élevés ou faibles ne doivent pas être interprétés uniquement à partir du total, mais un professionnel doit tenir compte du fonctionnement adaptatif, du développement, de l’éducation et du langage, le cas échéant."
      ]
    },
    {
      "heading": "Lisez le profil, pas seulement le numéro",
      "paragraphs": [
        "Deux personnes ayant le même score global peuvent avoir des points forts différents. L’une peut exceller dans le raisonnement verbal, tandis que l’autre peut être plus performante dans les modèles visuels.",
        "Utilisez une partition en ligne comme un instantané dans des conditions particulières, pas comme une étiquette permanente."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Qu'est-ce qui est considéré comme un QI élevé?",
      "answer": "À de nombreuses échelles, 120 ou plus est bien au-dessus de la moyenne et 130 ou au-dessus est autour du sommet 2%, mais la terminologie varie."
    },
    {
      "question": "Les limites de la fourchette de QI sont-elles exactes?",
      "answer": "L'erreur de mesure et les différents systèmes de classification rendent les limites approximatives."
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
